module.exports = __webpack_public_path__ + "static/media/nike-the-mystery-of-giulia-gwinn.9414f728.mp4";